var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "6.25 7.25 17.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5563 21.814L8.26093 15.4405C6.48771 13.6453 6.59937 10.7017 8.50337 9.04945C10.3923 7.4103 13.2563 7.7286 14.749 9.74356L15 10.0823L15.251 9.74356C16.7437 7.7286 19.6077 7.4103 21.4966 9.04945C23.4006 10.7017 23.5123 13.6453 21.739 15.4405L15.4437 21.814C15.1986 22.062 14.8014 22.062 14.5563 21.814Z",
    fill: "#D65B5B",
    stroke: "#D65B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.5C20.5 14 21 12 20.5 11.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteHeart);
export default __webpack_public_path__ + "static/media/favorite-heart.692b96917e062e406537c3fd21825315.svg";
export { ForwardRef as ReactComponent };